import {FieldType} from '../../../models/field-type';

export class InsurerDataModeConfig {

  /**
   * mode of insurer data section
   */
  mode: InsurerDataMode;

  /**
   * dictionary behaviour strategy
   */
  dictionaryMode?: DictionaryMode;

  /**
   * strategy of requesting updated dictionaries;
   * only in DYNAMIC dictionary mode
   */
  dictionaryRequestStrategy?: DictionaryRequestStrategy;

  /**
   * debounce time for requesting dictionary (ms);
   * only in DYNAMIC dictionary mode
   */
  debounceTime?: number;

  streetConfig?: AddressItemConfig;
  cityConfig?: AddressItemConfig;
  countyVisible?: boolean;
  isCountyRequired?: boolean;
}

export interface AddressItemConfig {
  fieldType: FieldType;
  requiredStrategy?: RequiredStrategy;
  searchTermMinLength?: number; // minimum length of search term that triggers requesting new filtered version of dictionary
  typeForResultsMessage?: string; // message displayed in select when search term isn't long enough to request a dictionary
}

export enum InsurerDataMode {
  STANDARD = 'STANDARD', // no dictionaries; postal code is validated from static resource
  DICTIONARY = 'DICTIONARY', // no static postal code validation; city/street values are limited by dictionaries
}

export enum DictionaryMode {
  STATIC = 'STATIC', // dictionary is requested only once at beginning
  DYNAMIC = 'DYNAMIC' // dictionary is requested every time user typed new letters (details depend on dictionary request strategy)
}

export enum DictionaryRequestStrategy {
  DEBOUNCING = 'DEBOUNCING' // request dictionary when debounce time has elapsed and input value didn't change
}

export enum RequiredStrategy {
  ALWAYS_REQUIRED = 'ALWAYS_REQUIRED', // default; field is always required - even if dictionary is empty
  REQUIRED_IF_DICTIONARY_EXISTS = 'REQUIRED_IF_DICTIONARY_EXISTS', // field is required if current dictionary is not empty
  NOT_REQUIRED = 'NOT_REQUIRED' // field is not required - regardless of dictionary content
}
